import { useNavigate } from "react-router-dom";

import { Button } from "@/ui";
import { useAuth } from "@/contexts/auth-context";

function NotFound() {
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();
  const CTA = isLoggedIn ? "Go to Notebook" : "Get Started";
  return (
    <section>
      <div className="py-8 px-4 mx-auto max-w-screen-xl text-center lg:py-16 lg:px-12">
        <h1 className="mb-4 text-4xl font-extrabold tracking-tight leading-none text-ink-primary md:text-5xl lg:text-6xl">
          Page Not Found!
        </h1>
        <div className="flex flex-col mb-8 lg:mb-16 space-y-4 sm:flex-row sm:justify-center sm:space-y-0 sm:space-x-4">
          <div className="py-2.5">
            <Button
              variant="gradient"
              size="lg"
              fullWidth
              onClick={() => navigate("/")}
            >
              Go Home
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default NotFound;
